import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Tooltip from 'rc-tooltip';
import Confirm from '../../components/Confirm.js';
import General from '../../modules/General';
import uuidV4 from 'uuid/v4';
import Notification from '../../components/Notification';
import ChatTemplate from "./form/ChatTemplate";

class Template extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name:'',
            message:'',
            isError:false,
            isLoading:true,
        }

        this.handleTemplateSubmit = this.handleTemplateSubmit.bind(this);


    }

    handleTemplateSubmit(values) {
        this.setState({
            isLoading:true,
        });

        let method = 'post';
        let url = '/chat/templates';

        if(this.props.templateId) {
            method = 'put';
            url += '/'+this.props.templateId;
        }

        axios[method](url,values).then(res => {
            Notification.success('Template saved');
            this.setState({
                isLoading:false,
            });

            this.props.handleSave(res.data);
            this.props.onClose();
        });

    }



    componentWillMount() {
        if(!this.props.templateId) {
            this.setState({'isLoading':false});
            return true;
        }
        axios.get(`/chat/templates/${this.props.templateId}`)
            .then(res => {
                this.setState({
                    'isLoading':false,
                    name:res.data.name,
                    message:res.data.message,
                });
            })
            .catch(res => {
                console.dir(res);
                this.setState({'isError':'Template not found'});
            });
    }

    render() {

        if(this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }

        return (
            <div className="overview m-t-30 col-sm-6 offset-sm-3 text-center">
                <h1>Message template</h1>

                <ChatTemplate initialValues={{name:this.state.name,message:this.state.message}} onSubmit={this.handleTemplateSubmit} />

            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


Template = connect(mapStateToProps,mapDispatchToProps)(Template);
export default Template;


// WEBPACK FOOTER //
// ./containers/settings/Template.js